export default __webpack_public_path__ + "static/media/AkzidenzGrotesk.7d2dbda5.woff2";